import { render, staticRenderFns } from "./SuppliersManufactureList.vue?vue&type=template&id=65ecaa11&scoped=true&"
import script from "./SuppliersManufactureList.vue?vue&type=script&lang=js&"
export * from "./SuppliersManufactureList.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersManufactureList.vue?vue&type=style&index=0&id=65ecaa11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ecaa11",
  null
  
)

export default component.exports